import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createTipoIngreso, updateTipoIngreso, fetchTipoIngreso } from '../actions/tipoIngresoActions';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

const TipoIngresoForm = ({ show, handleClose, isEdit, selectedId }) => {
    const dispatch = useDispatch();
    const { currentTipoIngreso, error } = useSelector(state => state.tipoIngreso);
    const [formData, setFormData] = useState({
        codigo: '',
        nombre: '',
        montoref: 0.00
    });
    const isInscripcion = isEdit && formData.codigo?.toString().trim().toUpperCase() === 'INSCRIP';

    useEffect(() => {
        if (isEdit && selectedId) {
            dispatch(fetchTipoIngreso(selectedId));
        }
    }, [dispatch, isEdit, selectedId]);

    useEffect(() => {
        if (isEdit && currentTipoIngreso && currentTipoIngreso.id === selectedId) {
            setFormData({
                codigo: currentTipoIngreso.codigo,
                nombre: currentTipoIngreso.nombre,
                montoref: currentTipoIngreso.montoref
            });
        }
    }, [currentTipoIngreso, isEdit, selectedId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === 'montoref' ? parseFloat(value) : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.codigo || !formData.nombre || formData.montoref === undefined) {
            toast.error("Todos los campos son obligatorios");
            return;
        }

        if (isEdit) {
            dispatch(updateTipoIngreso(selectedId, formData))
                .then(() => {
                    toast.success("Tipo de ingreso actualizado");
                    handleClose();
                })
                .catch((error) => {
                    toast.error(`Error: ${error.message}`);
                });
        } else {
            dispatch(createTipoIngreso(formData))
                .then(() => {
                    toast.success("Tipo de ingreso creado");
                    handleClose();
                })
                .catch((error) => {
                    toast.error(`Error: ${error.message}`);
                });
        }
    };

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{isEdit ? 'Editar Tipo de Ingreso' : 'Nuevo Tipo de Ingreso'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {isInscripcion && (
                        <div className="alert alert-info py-2">
                            Este tipo de ingreso es usado para la inscripcion de nuevos socios. Solo puede modificar el monto.
                        </div>
                    )}
                    <Form.Group className="mb-3">
                        <Form.Label>Código</Form.Label>
                        <Form.Control
                            type="text"
                            name="codigo"
                            value={formData.codigo}
                            onChange={handleChange}
                            required
                            maxLength={10}
                            disabled={isInscripcion}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                            disabled={isInscripcion}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Monto Referencial ($)</Form.Label>
                        <Form.Control
                            type="number"
                            name="montoref"
                            value={formData.montoref}
                            onChange={handleChange}
                            step="0.01"
                            min="0"
                            required
                        />
                    </Form.Group>
                    <div className="d-flex justify-content-end gap-2">
                        <Button variant="secondary" onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" type="submit">
                            {isEdit ? 'Actualizar' : 'Guardar'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default TipoIngresoForm;